/**
 * BELLA VITA – Microsoft-Clarity-Events
 *
 * Erfasst Klicks auf Growave-Wunschlisten-Icons
 * auf Produktseiten, in Produkt-Grids und weiteren Bereichen.
 *
 * Unterscheidet zwischen:
 * - Zur Wunschliste hinzugefügt - Icon
 * - Von Wunschliste entfernt - Icon
 */

(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      const eventPath =
        typeof event.composedPath === 'function'
          ? event.composedPath()
          : [];

      const wishlistButton = eventPath.find(function (element) {
        return (
          element instanceof Element &&
          element.matches('.gw-toggle-wishlist-product-card-button')
        );
      });

      if (!wishlistButton) return;

      /*
       * Zustand vor der Growave-Aktion:
       *
       * false = Produkt ist noch nicht auf der Wunschliste
       * true  = Produkt befindet sich bereits auf der Wunschliste
       */
      const isAlreadyInWishlist =
        wishlistButton.getAttribute('data-in-wishlist') === 'true';

      const clarityEventName = isAlreadyInWishlist
        ? 'Von Wunschliste entfernt - Icon'
        : 'Zur Wunschliste hinzugefügt - Icon';

      if (typeof window.clarity === 'function') {
        window.clarity('event', clarityEventName);

        console.log(
          '[Bella Vita Clarity] Event gesendet:',
          clarityEventName
        );
      }
    },
    true
  );
})();